import { render, staticRenderFns } from "./CancelBrandSubscription.vue?vue&type=template&id=2c4fc3a8&scoped=true&"
import script from "./CancelBrandSubscription.vue?vue&type=script&lang=ts&"
export * from "./CancelBrandSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./CancelBrandSubscription.vue?vue&type=style&index=0&id=2c4fc3a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4fc3a8",
  null
  
)

export default component.exports